import { http } from 'utils'

import { IcashTopupTxServiceTypes } from 'types/icashTopupTxTypes'
import { IcashTopupReversalTxServiceTypes } from 'types/icashTopupReversalTxTypes'
import { IcashRedemptionTxServiceTypes } from 'types/icashRedemptionTxTypes'
import { IcashRedemptionReversalTxServiceTypes } from 'types/icashRedemptionReversalTxTypes'
import { IcashDonationTxServiceTypes } from 'types/icashDonationTxTypes'
import { IcashDonationRefundTxServiceTypes } from 'types/icashDonationRefundTxTypes'
import { specialIcashRefundTxServiceTypes } from 'types/specialIcashRefundTxTypes'

export async function topUpAPI({
  creditValue,
  externalTransactionId,
  ident,
  cashier,
  guid,
  storeId,
  deviceCode,
  transactionDate,
  comments,
  traceNumber,
  reasonId,
  pin,
}: IcashTopupTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/top-up'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    cashier,
    guid,
    storeId,
    deviceCode,
    transactionDate,
    comments,
    traceNumber,
    reasonId,
    pin
  }
  return await http.post(url, data)
}

export async function topUpReversalAPI({
  externalTransactionId,
  ident,
  storeId,
  cashier,
  comments,
  traceNumber,
  reasonId,
  pin,
}: IcashTopupReversalTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/top-up-reversal'
  const data = {
    externalTransactionId,
    ident,
    storeId,
    cashier,
    comments,
    traceNumber,
    reasonId,
    pin
  }
  return await http.post(url, data)
}

export async function redemptionAPI({
  creditValue,
  externalTransactionId,
  ident,
  pin,
  cashier,
  guid,
  storeId,
  deviceCode,
  transactionDate,
  comments,
  traceNumber,
  reasonId,
}: IcashRedemptionTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/redemption'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    pin,
    cashier,
    guid,
    storeId,
    deviceCode,
    transactionDate,
    comments,
    traceNumber,
    reasonId,
  }
  return await http.post(url, data)
}

export async function redemptionReversalAPI({
  externalTransactionId,
  ident,
  storeId,
  cashier,
  comments,
  traceNumber,
  reasonId,
  pin,
}: IcashRedemptionReversalTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/redemption-reversal'
  const data = {
    externalTransactionId,
    ident,
    storeId,
    cashier,
    comments,
    traceNumber,
    reasonId,
    pin,
  }
  return await http.post(url, data)
}

export async function donationAPI({
  traderId,
  creditValue,
  externalTransactionId,
  ident,
  storeId,
  deviceCode,
  cashier,
  guid,
  transactionDate,
  comments,
  traceNumber,
  reasonId,
  pin,

}: IcashDonationTxServiceTypes): Promise<void> {
  let url = '/manual-transaction/donation'
  const params = new URLSearchParams()

  if (traderId) {
    params.set('traderId', traderId.toString())
  }
  url += `?${params.toString()}`

  const data = {
    creditValue,
    externalTransactionId,
    ident,
    cashier,
    guid,
    storeId,
    deviceCode,
    transactionDate,
    comments,
    traceNumber,
    reasonId,
    pin,
  }
  return await http.post(url, data)
}

export async function donationReversalAPI({
  ident,
  externalTransactionId,
  creditValue,
  fromTraderId,
  // comments,
  // traceNumber,
  // reasonId,
  pin,
}: IcashDonationRefundTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/donation-refund'
  const data = {
    externalTransactionId,
    ident,
    creditValue,
    fromTraderId,
    // comments,
    // traceNumber,  
    // reasonId,
    pin,
  }
  return await http.post(url, data)
}

export async function specialIcashRefundAPI({
  creditValue,
  externalTransactionId,
  ident,
  storeId,
  deviceCode,
  cashier,
  guid,
  comments,
  traceNumber,
  reasonId,
}: specialIcashRefundTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/special-icash-refund'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    storeId,
    deviceCode,
    cashier,
    guid,
    comments,
    traceNumber,
    reasonId,
  }
  return await http.post(url, data)
}